import { KeycloakService } from './KeycloakService'

import { appConfig } from 'Config'

export const keycloakService = new KeycloakService(appConfig.keycloakAdminApi)
